import { httpDelete } from '@/lib/api/rest';

export function destroySession(httpDelete) {
  return async function execute() {
    /* istanbul ignore next: development data */
    if (!process.env.DEMO) {
      await httpDelete('/sessions');
    }
  };
}

export default destroySession(httpDelete);
